<div class="mb-2">
  <mat-expansion-panel class="accordion accordion-maintenance accordion-secondary">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span class="index-number">{{ index + 1 }}</span> Tarea: {{ formGroup.get('taskName')?.value || 'Nueva tarea ' }}
      </mat-panel-title>
      <button 
        class="button button-danger button-xs mr-2" 
        (click)="onRemoveTask($event)">
        <i class="fas fa-trash-can" aria-hidden="true"></i>
      </button>

    </mat-expansion-panel-header>

    <div [formGroup]="formGroup">
      <div class="grid grid-cols-1 md:grid-cols-12 gap-4 mb-5">
        <div class="md:col-span-8">
          <label>Selecciona una tarea existente</label>
          <mat-select class="select" formControlName="taskId" (selectionChange)="formGroup.get('taskName')?.setValue($event.source.triggerValue)">
            <mat-option *ngFor="let task of tasks" [value]="task.id">{{ task.name }}</mat-option>
          </mat-select>
          <div *ngIf="formGroup.get('taskId')?.invalid && (formGroup.get('taskId')?.dirty || formGroup.get('taskId')?.touched)" class="text-red-500">
            Tarea es requerida.
          </div>
        </div>
        <div class="md:col-span-2">
          <label class="hidden md:inline-block"></label>
          <input class="input" type="number" formControlName="order" placeholder="Orden">
          <div *ngIf="formGroup.get('order')?.invalid && (formGroup.get('order')?.dirty || formGroup.get('order')?.touched)" class="text-red-500">
            El orden es obligatorio.
          </div>
        </div>
        
        <div class="md:col-span-2">
          <mat-checkbox class="md:mt-4" formControlName="required">Requerido</mat-checkbox>
        </div>

        <!-- Botón para abrir el modal de visación -->
        <div class="md:col-span-4" *ngIf="isMaintenanceUpdate" style="background-color: #fbd9a3; padding: 1rem; border-radius: 0.5rem;">
          <p>
            La siguiente tarea debe ser aprobado antes de que se empiece a utilizar en la mantención seleccionada.
            Una vez termine su configuración presione el botón “Notificar Cambio” para dar curso a la solicitud.
          </p>
          <button mat-button color="primary" (click)="openVisationModal('task')" style="background-color: #f59e0b; color: white; border-radius: 0.5rem; padding: 0.5rem 1rem;">
            Agregar Visación
          </button>
        </div>
      </div>
      <!-- Orden y Requerido fields -->
      <!--
        <div class="flex items-center mr-4">
          <mat-form-field appearance="outline" class="order-field">
            <mat-label>Orden</mat-label>
            <input matInput type="number" formControlName="order" placeholder="Orden">
          </mat-form-field>
          <mat-checkbox formControlName="required">Requerido</mat-checkbox>
        </div>
      -->
      <!-- End of Orden y Requerido fields -->      
      <div class="flex items-center justify-center my-4" *ngIf="getAcceptanceCriteriaFormArray()?.length == 0 && elementsFormArray?.length == 0">
        <button class="button button-outlined-secondary button-sm mr-2" (click)="addElement()">Agregar Elemento</button>
        <button class="button button-outlined-secondary button-sm ml-2" (click)="addAcceptanceCriteria()">Agregar Criterio de Aceptación</button>
      </div>
      <!--<button mat-button (click)="addElement()">Agregar Elemento</button>-->
      <div *ngIf="elementsFormArray && elementsFormArray.length > 0" formArrayName="elements" class="task-elements">
        <div *ngFor="let elementCtrl of elementsFormArray.controls; let j = index" [formGroupName]="j">
          <app-element-create [index]="j" [formGroup]="getElementFormGroup(elementCtrl)" [isMaintenanceUpdate]="isMaintenanceUpdate" (remove)="removeElement(j)"></app-element-create>
        </div>
        <div class="flex justify-end mt-4">
          <button class="button button-outlined-primary button-sm" (click)="addElement()">Agregar Elemento</button>
        </div>
      </div>
      <!--<button mat-button (click)="addAcceptanceCriteria()">Agregar Criterio de Aceptación</button>-->
      <div *ngIf="getAcceptanceCriteriaFormArray() && getAcceptanceCriteriaFormArray().length > 0" formArrayName="acceptanceCriterias" class="task-criterias">
        <div *ngFor="let criteriaCtrl of getAcceptanceCriteriaFormArray().controls; let k = index; trackBy: trackByFn" [formGroupName]="k">
          <mat-expansion-panel class="accordion accordion-maintenance accordion-default">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="index-number">{{ k + 1 }}</span> Criterio de Aceptación: {{criteriaCtrl.get('acceptanceCriteriaName')?.value || 'Nuevo Criterio de Aceptación '}}
              </mat-panel-title>
              <button class="button button-danger button-xs mr-2" (click)="removeAcceptanceCriteria(k)">
                <i class="fas fa-trash-can" aria-hidden="true"></i>
              </button>
            </mat-expansion-panel-header>
            <div>
              <div class="grid grid-cols-1 md:grid-cols-12 gap-4 mb-5">
                <div class="md:col-span-8">
                  <label>Selecciona un criterio de aceptación existente</label>
                  <mat-select class="select" placeholder="Selecciona un criterio de aceptación existente" formControlName="acceptanceCriteriaId" (selectionChange)="updateAcceptanceCriteriaName(k, $event.value)">
                    <mat-option *ngFor="let criteria of acceptanceCriterias" [value]="criteria.id">{{ criteria.name }}</mat-option>
                  </mat-select>
                  <div *ngIf="criteriaCtrl.get('acceptanceCriteriaId')?.invalid && criteriaCtrl.get('acceptanceCriteriaId')?.touched" class="text-red-500">
                    Criterio de aceptación es requerido.
                  </div>
                </div>
                <div class="md:col-span-2">
                  <label class="hidden md:inline-block"></label>
                  <input class="input" type="number" formControlName="order" placeholder="Orden">
                  <div *ngIf="criteriaCtrl.get('order')?.invalid && (criteriaCtrl.get('order')?.dirty || criteriaCtrl.get('order')?.touched)" class="text-red-500">
                    El orden es obligatorio.
                  </div>
                </div>
                <div class="md:col-span-2">
                  <mat-checkbox class="md:mt-4" formControlName="required">Requerido</mat-checkbox>
                </div>

                <!-- Botón para abrir el modal de visación -->
                <div class="md:col-span-4" *ngIf="isMaintenanceUpdate" style="background-color: #fbd9a3; padding: 1rem; border-radius: 0.5rem;">
                  <p>
                    El siguiente criterio debe ser aprobado antes de que se empiece a utilizar en la mantención seleccionada.
                    Una vez termine su configuración presione el botón “Notificar Cambio” para dar curso a la solicitud.
                  </p>
                  <button mat-button color="primary" (click)="openVisationModal('acceptanceCriteria', k)" style="background-color: #f59e0b; color: white; border-radius: 0.5rem; padding: 0.5rem 1rem;">
                    Notificar Cambio
                  </button>
                </div>
              </div>
              <!-- Orden y Requerido fields -->
              <!--
                <div class="flex items-center mr-4">
                  <mat-form-field appearance="outline" class="order-field">
                    <mat-label>Orden</mat-label>
                    <input matInput type="number" formControlName="order" placeholder="Orden">
                  </mat-form-field>
                  <mat-checkbox formControlName="required">Requerido</mat-checkbox>
                </div>
              -->
              <!-- End of Orden y Requerido fields -->
              <div *ngIf="getAcceptanceCriteriaElementsFormArray(k).controls.length == 0" class="flex justify-end">
                <button class="button button-outlined-secondary button-sm" (click)="addElementToAcceptanceCriteria(k)">Agregar Elemento</button>
              </div>

              <div *ngIf="getAcceptanceCriteriaElementsFormArray(k).controls.length > 0" formArrayName="elements" class="criteria-elements">
                <div *ngFor="let elementCtrl of getAcceptanceCriteriaElementsFormArray(k).controls; let l = index" [formGroupName]="l">
                  <app-element-create [index]="l" [formGroup]="getElementFormGroup(elementCtrl)" [isMaintenanceUpdate]="isMaintenanceUpdate" (remove)="removeElementFromAcceptanceCriteria(k, l)"></app-element-create>
                </div>
                <div class="flex justify-end">
                  <button class="button button-outlined-primary button-sm" (click)="addElementToAcceptanceCriteria(k)">Agregar Elemento</button>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </div>

        <div class="flex justify-end mt-2">
          <button class="button button-outlined-primary button-sm" (click)="addAcceptanceCriteria()">Agregar Criterio de Aceptación</button>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</div>
